module.exports = __webpack_public_path__ + "img/book.906623c5.gif";